export const ENTITY = {
  AD: 'Ad',
  KEYWORD: 'Keyword',
  CUSTOMIZERFEED: 'CustomizerFeed',
  EXTENSION: 'Extension',
  ASSETGROUP: 'AssetGroup',
  ASSET: 'Asset',
};

export const CategoryFAID = {
  2: 'Adult_General',
  3: 'Alcohol_General',
  29: 'Pharmacy_General',
  99: 'Adult_Porn_Adult_Entertainment',
  100: 'Adult_Illegal_Adult_Content',
  119: 'Political_Politicians',
  180: 'Disallowed_Content_Abortion',
  221: 'Mature_Content',
  222: 'Mature_Content',
  224: 'Mature_Content',
  225: 'Mature_Content',
  226: 'Mature_Content',
  227: 'Mature_Content',
  228: 'Mature_Content',
  262: 'Cryptocurrency',
  263: 'Cryptocurrency',
  264: 'Cryptocurrency',
  265: 'Cryptocurrency',
  266: 'Cryptocurrency',
  281: 'Birth_Control',
  282: 'Dating',
  283: 'Fertility_Treatment',
  292: 'Background_Checks',
  299: 'Payday_Loans',
  308: 'Penny_Stocks',
  311: 'Psychics',
  315: 'Tobacco_Image',
  316: 'Alcohol_Image',
  317: 'Unsubstantiated_Claim_Image',
  334: 'Tobacco_Category',
  335: 'Lingerie_Explicit',
  280: 'Sensitive_Health',
  340: 'Sensitive_Health',
  223: 'Sensitive_Health',
  341: 'Misinformation',
  342: 'Drug_Paraphanelia_Category',
  364: 'Sexual_Health_And_Erotica',
  365: 'Skin_Exposure',
  521: 'Ad_Functionality',
  522: 'Unbranded_Creative',
  523: 'End_Of_Life_Services',
  524: 'Tattoo_And_Piercings',
  525: 'Weapon_Accessories_And_Concealed_Permits',
  533: 'Spam',
};

export const CategoryFALink = {
  Adult_General: 'https://go.microsoft.com/fwlink/?linkid=2207051',
  Alcohol_General: 'https://about.ads.microsoft.com/en-us/policies/restricted-categories/alcohol',
  Pharmacy_General: 'https://go.microsoft.com/fwlink/?linkid=2194266',
  Adult_Porn_Adult_Entertainment: 'https://go.microsoft.com/fwlink/?linkid=2207051',
  Adult_Illegal_Adult_Content: 'https://go.microsoft.com/fwlink/?linkid=2207051',
  Political_Politicians: 'http://advertise.bingads.microsoft.com/en-us/disallowed-content-policies',
  Disallowed_Content_Abortion: 'https://go.microsoft.com/fwlink/?linkid=2194368',
  Mature_Content: 'https://go.microsoft.com/fwlink/?linkid=2207051',
  Cryptocurrency: 'https://go.microsoft.com/fwlink/?linkid=2194432',
  Birth_Control: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/microsoft-audience-ads',
  Dating: 'https://advertise.bingads.microsoft.com/en-us/resources/policies',
  Fertility_Treatment: 'https://advertise.bingads.microsoft.com/en-us/resources/policies',
  Background_Checks: 'https://go.microsoft.com/fwlink/?linkid=2206943',
  Payday_Loans: 'https://advertise.bingads.microsoft.com/en-us/resources/policies',
  Penny_Stocks: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/microsoft-audience-ads',
  Psychics: 'https://go.microsoft.com/fwlink/?linkid=2194268',
  Tobacco_Image: 'https://about.ads.microsoft.com/en-us/policies/disallowed-content/tobacco-products',
  Alcohol_Image: 'https://about.ads.microsoft.com/en-us/policies/restricted-categories/alcohol',
  Unsubstantiated_Claim_Image: 'https://advertise.bingads.microsoft.com/en-us/resources/policies',
  Tobacco_Category: 'https://about.ads.microsoft.com/en-us/policies/disallowed-content/tobacco-products',
  Lingerie_Explicit: 'https://advertise.bingads.microsoft.com/en-us/resources/policies',
  Sensitive_Health: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/microsoft-audience-ads',
  Misinformation: 'https://go.microsoft.com/fwlink/?linkid=2205489',
  Drug_Paraphanelia_Category: 'https://about.ads.microsoft.com/en-us/policies/disallowed-content/drugs-and-related-paraphernalia',
  Sexual_Health_And_Erotica: 'http://advertise.bingads.microsoft.com/en-us/adult-content-policies',
  Skin_Exposure: 'https://go.microsoft.com/fwlink/?linkid=2207051',
  Ad_Functionality: 'https://go.microsoft.com/fwlink/?linkid=2207237',
  Unbranded_Creative: 'https://about.ads.microsoft.com/en-us/policies/general-ad-requirements',
  End_Of_Life_Services: 'https://go.microsoft.com/fwlink/?linkid=2194519',
  Tattoo_And_Piercings: 'https://go.microsoft.com/fwlink/?linkid=2206948',
  Weapon_Accessories_And_Concealed_Permits: 'https://go.microsoft.com/fwlink/?linkid=2194366',
  Spam: 'https://help.ads.microsoft.com/#apex/ads/en/60215/0-500',
};

export const ENTITYToI18 = {
  Ad: 'EditorialAppeal_Entity_Ad',
  Keyword: 'EditorialAppeal_Entity_Keyword',
  AssetGroup: 'EditorialAppeal_Entity_Assetgroup',
  Extension: 'EditorialAppeal_Entity_Extension',
  Asset: 'EditorialAppeal_Entity_Asset',
};
export const ENTITYPluralToI18 = {
  Ad: 'EditorialAppeal_Entity_Ad_Plural',
  Keyword: 'EditorialAppeal_Entity_Keyword_Plural',
  AssetGroup: 'EditorialAppeal_Entity_Assetgroup_Plural',
  Extension: 'EditorialAppeal_Entity_Extension_Plural',
  Asset: 'EditorialAppeal_Entity_Asset_Plural',
};

export const BLACKLIST = [
  'Incomplete',
  'GeoCodingIncomplete',
  'InlineOpportunity',
];
